import { api, qs } from '../client'
import type { HashtagPage, Page, Post, TimelineKind } from '../types'

export const timelineApi = {
  home: (cursor?: string, limit = 20, kind?: TimelineKind) =>
    api.get<Page<Post>>(`/timeline/home${qs({ cursor, limit, kind })}`),

  /** 顶部"有 N 条新帖" */
  homeNewCount: (since: string) =>
    api.get<{ count: number }>(`/timeline/home${qs({ since })}`).then((r) => r.count),

  explore: (cursor?: string, limit = 20, kind?: TimelineKind) =>
    api.get<Page<Post>>(`/timeline/explore${qs({ cursor, limit, kind })}`),

  /** 为你推荐（D83）。每条多一个 `context`；next_cursor 指向服务端的排序快照（D84） */
  forYou: (cursor?: string, limit = 20, kind?: TimelineKind) =>
    api.get<Page<Post>>(`/timeline/foryou${qs({ cursor, limit, kind })}`),

  /** 话题页。话题不存在时返回空页，hashtag.post_count 为 0 */
  hashtag: (name: string, cursor?: string, limit = 20, kind?: TimelineKind) =>
    api.get<HashtagPage>(
      `/timeline/hashtag/${encodeURIComponent(name)}${qs({ cursor, limit, kind })}`,
    ),
}
